
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SessionService } from './session.service';
import { _common } from './_common';

@Component({
    selector: 'app-verify-password',
    templateUrl: './verify.password.error.component.html',
    standalone: true
})
export class VerifyPasswordErrorComponent implements OnInit {


  _common = _common;
  app: string = "thinkshops"
  subscription: Subscription;
  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
  ) {

    this.subscription = this.route.queryParams.subscribe((params) => {

      this.app = params.app;

      SessionService.fixTitle(this.app);


    })
  }

  ngOnInit() {

  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }


}
